import type { BairroAtendido, BairroDisponivel } from "../../../services/atribuirBairros"
import type { CidadeView } from "../../../services/atribuirRegiao"

export type { BairroAtendido, BairroDisponivel, CidadeView }

export type AtribuirBairrosModel = {
    atendidos: BairroAtendido[]
    naoAtendidos: BairroDisponivel[]
    cidadesEstabelecimento: CidadeView[]
    todasCidades: CidadeView[]
    idCidadeSelecionada: number | null
    taxa: string
    taxaNoturna: string
    minimoEntregaGratis: string
    taxaEntregador: string
    idsBairrosSelecionados: number[]
}

export const AtribuirBairrosInicial: AtribuirBairrosModel = {
    atendidos: [],
    naoAtendidos: [],
    cidadesEstabelecimento: [],
    todasCidades: [],
    idCidadeSelecionada: null,
    taxa: "",
    taxaNoturna: "",
    minimoEntregaGratis: "",
    taxaEntregador: "",
    idsBairrosSelecionados: [],
}
